export default "__VITE_ASSET__t1KrLUdH__"